import Chip, { ChipProps, ChipSize } from '@platform-ui-common/components/Chip/index.js';
import Tooltip from '@platform-ui-common/components/Tooltip/index.js';

type ReferralChipProps = Pick<ChipProps, 'variant'>;

export default function ReferralChip(props: ReferralChipProps): JSX.Element {
  return (
    <Tooltip title="This program is recommended for you because of the information you shared with us in your last application.">
      <Chip size={ChipSize.S} icon="referral" label="Recommended for you" {...props} />
    </Tooltip>
  );
}
